import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { cart } from '~/constants/siteConfig';
import CommonSwiper from '../../common/CommonSwiper/CommonSwiper';

const GuestFavouritesSection = (): ReactElement => {
  const { t: tHome } = useTranslation('', { keyPrefix: '$pages.$home.$guestFavourites' });
  const { ymalName1 } = cart;

  return (
    <section
      id="hp-guest-favourites"
      className="hp-guest-favourites hp-section carousel-overflow common-carousel"
    >
      <h2 className="italic">{tHome('heading')}</h2>
      <CommonSwiper ymalName={ymalName1} isHomepageList imgLoading="eager" />
    </section>
  );
};

export default GuestFavouritesSection;
